import type { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/free-solid-svg-icons";

interface EmptyStateProps {
    readonly icon: IconDefinition;
    readonly title: string;
    readonly description: ReactNode;
}

export function EmptyState({ icon, title, description }: EmptyStateProps) {
    return (
        <div className="flex flex-col items-center justify-center gap-3 rounded-3xl border border-dashed border-white/15 bg-white/5 px-8 py-12 text-center text-white">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white/10">
                <FontAwesomeIcon icon={icon} className="h-6 w-6 text-white/70" />
            </div>
            <h3 className="text-lg font-semibold">{title}</h3>
            <p className="max-w-md text-sm text-white/60">{description}</p>
        </div>
    );
}
